module.exports = __webpack_public_path__ + "img/icon-sw.45c57425.svg";